<template>
  <div class="form">
    <div
      v-if="qaTipsVisible"
    >
      <div class="qa-tip">
        <div class="inner">
          <h2>元气UP认证Q&A</h2>
          <dl>
            <dt>Q：为什么要成为元气UP？</dt>
            <dd>A：成为元气UP后，您可以上传具有完全知识产权或者经过合法授权的壁纸作品，并将其设置为需要鱼干/会员赞赏，我们会根据壁纸质量确定赞赏金额，并进行推荐。当用户使用小鱼干赞赏或以vip身份下载您上传的需赞赏的壁纸，您将获得元宝收益，元宝可用于提现。</dd>
          </dl>
          <dl>
            <dt>Q：如何认证成为元气UP？</dt>
            <dd>A：在元气桌面上传过具有完全知识产权或者经过合法授权的壁纸作品，且上传的作品下载总量达到100，则可认证元气UP。</dd>
          </dl>
          <dl>
            <dt>Q：为什么需要进行实名认证？</dt>
            <dd>A：实名认证可确保您的身份真实且唯一，若您上传至本平台的壁纸作品因知识产权引起任何纠纷，将完全由您个人承担，平台不承担任何责任。</dd>
          </dl>
          <dl>
            <dt>Q：实名认证后，我的付费壁纸收益提现后，怎么报税？</dt>
            <dd>A：<strong>签约后将建立与本公司（海南豹趣科技有限公司）的劳务合同关系</strong>，提现后将在下个月的15日左右向税务机关代缴劳务所得税/个人所得税，<strong>详细信息可在个人所得税App中查询</strong>。如果对提现或报税有任何疑问，可联系客服QQ 1803780781，<strong>如因个人原因导致的报税失败，将会影响后续提现</strong>。</dd>
          </dl>
          <dl>
            <dt>Q：为什么需要提交动态壁纸？可以提交静态图吗？</dt>
            <dd>A：元气UP可将自己上传的动态壁纸设置为需要鱼干/会员赞赏，为保证平台壁纸的质量，平台会对申请者进行动态壁纸创作能力考核，考核方式为审核申请者提交的动态壁纸。因此认证元气UP必须提交动态壁纸，提交静态图片将不予通过认证。</dd>
          </dl>
          <dl>
            <dt>Q：我已经认证成为了元气UP主，要如何认证成为元气大UP呢？</dt>
            <dd>A：目前拥有动态壁纸制作能力、擅长人物形态动效制作、且作品质量经过官方认证的动效制作者可认证成为元气大UP主。如果您是专业的动效制作者，可联系QQ2493045441的工作人员进行申请，申请备注：申请元气大UP。</dd>
          </dl>
        </div>
      </div>
      <div class="qa-ctrl ctrl">
        <span
          class="btn-publish"
          @click="handleHideQaTips"
        >认证元气UP</span>
      </div>
    </div>
    <div v-else class="contract-upload-wrap">
      <div class="hd">
        <div class="tip">
          请如实填写以下各项信息，如有虚假将可能导致认证不通过
        </div>
      </div>
      <div class="upload-form">
        <div class="l">
          <div class="row flex-row">
            <div class="sub-row flex1-3">
              <label><em class="hl">*</em>作者姓名：</label>
              <div class="s">
                <el-input
                  v-model="form.user_name"
                  placeholder="请填写您的真实姓名"
                  clearable
                />
              </div>
            </div>
          </div>
          <div class="row">
            <label><em class="hl">*</em><span class="fs">身份证：</span></label>
            <div class="s">
              <el-input
                v-model="form.idcard"
                clearable
              />
            </div>
          </div>
          <div class="row">
            <label><em class="hl">*</em>手机号码：</label>
            <div class="s">
              <el-input
                v-model="form.phone_number"
                placeholder="请填写11位有效手机号码"
                clearable
              />
            </div>
          </div>
          <div class="row flex-row">
            <div class="sub-row">
              <label><em class="hl">*</em>验证码：</label>
              <div class="s">
                <el-input
                  v-model="form.phone_code"
                  clearable
                />
              </div>
            </div>
            <div class="sub-row">
              <span
                v-if="sendSmscodeReady"
                class="btn-send-code"
                @click="handleSendSmscode"
              >获取验证码</span>
              <span
                v-else
                class="btn-send-code disable"
              >{{ countdownSendSmscode }}s</span>
            </div>
          </div>
          <div class="row">
            <label><em class="hl">*</em><span class="fs">QQ号码/微信 （优质内容官方会联系沟通合作事宜）：</span></label>
            <div class="s">
              <el-input
                v-model="form.qq"
                clearable
              />
            </div>
          </div>
          <div class="row">
            <div class="confirm">
              <el-checkbox v-model="treatyChecked">
                我已阅读并同意
              </el-checkbox>
              <a
                href="http://mobile-wallpaper-cdn.zhhainiao.com/mobile/agreement/yuanqiwallpaper-writter-cn.html "
                rel="noopener noreferrer"
                target="_blank"
              >《元气UP主签约协议》</a>
            </div>
          </div>
        </div>
        <div class="r">
          <div class="row">
            <label><em class="hl">*</em>个人简介：</label>
            <div class="s">
              <div class="form-textarea">
                <div class="textarea-inner">
                  <div
                    v-once
                    ref="textareaInput"
                    class="textarea-input"
                    contenteditable="plaintext-only"
                    @keyup="handleTextareaChange"
                    v-html="form.user_desc"
                  />
                  <input
                    v-model="form.user_desc"
                    type="text"
                    style="display:none"
                  >
                </div>
                <span class="remaining-words">{{ remainingWords - form.user_desc.length }}字</span>
              </div>
            </div>
          </div>
          <div class="row flex-row">
            <div class="sub-row">
              <label><em class="hl">*</em>个人作品：</label>
              <div class="s">
                <div
                  v-if="uploadVideoStatus === 'succ'"
                  class="upload-video-succ"
                >
                  <span
                    class="btn-remove"
                    @click="handleRemoveVideoResource"
                  ><i class="el-icon-delete" /></span>
                  <i class="icon-upload-succ" />
                  <p class="upload-succ-text">
                    上传成功
                  </p>
                </div>
                <div
                  v-else-if="uploadVideoStatus === 'process'"
                  class="upload-video-process"
                >
                  <Loading
                    class="loading-progress"
                    :rotate="uploadComplete"
                  />
                  <template v-if="uploadComplete < 100">
                    <p class="upload-process-text">
                      上传中({{ uploadComplete }}%)
                    </p>
                    <p
                      v-if="uploadSpeed"
                      class="upload-speed"
                    >
                      上传速率 {{ uploadSpeed }}
                    </p>
                  </template>
                  <p
                    v-else
                    class="upload-process-text"
                  >
                    正在处理中...
                  </p>
                </div>
                <el-upload
                  v-else
                  class="upload-video"
                  accept=".mp4,.rar,.png,.jpg,.jpeg,.zip"
                  drag
                  action=""
                  :http-request="handlePackageUpload"
                >
                  <p class="upload-info">
                    您可拖拽作品到此处
                  </p>
                  <p class="upload-sub">
                    或<span class="btn">浏览</span>以选择文件
                  </p>
                </el-upload>
              </div>
            </div>
            <div class="sub-row">
              <div class="tips-wrap">
                <p class="tips">
                  <span class="hl">*</span> 请上传原创或经过合法授权的视频壁纸，静态壁纸，支持MP4、rar、zip压缩包、PNG以及JPG，大小请控制在<span class="hl">200M</span>内。
                </p>
                <p class="tips">
                  <span class="hl">*</span> 请尽量保证视频的<span class="hl">清晰度</span>，否则将影响审核结果。
                </p>
                <p class="tips">
                  <span class="hl">*</span> 元气桌面承诺不会将您的作品用于其他用途，仅用于审核资质。
                </p>
              </div>
            </div>
          </div>
          <div class="ctrl">
            <span
              class="btn-publish"
              @click="handlePublish"
            >认证元气UP</span>
          </div>
        </div>
      </div>
      <div
        v-if="confirmDialogText"
        class="confirm-dalog-wrap"
      >
        <ConfirmDialog
          :text="confirmDialogText"
          :title="confirmDialogTitle"
          @close="handleConfirmDialogClose"
        />
      </div>
    </div>

    <div v-if="showUpAuthDialog || confirmDialogText" class="bar" />
    <UpAuthDialog v-model="showUpAuthDialog" class="up-auth-dialog" :now-downloads="userInfo.works_download_cnt + userInfo.works_mobile_download_cnt" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as SparkMD5 from 'spark-md5'
import EventEmit from '@/utils/EventEmit'

import ConfirmDialog from '@/components/dialog/ConfirmDialog'
import UpAuthDialog from '@/components/dialog/upAuthDialog'
import Loading from '@/components/Loading'
import { getSmsCoolDownTime, saveSmsCoolDownTime } from '@/utils/cache'

import {
  doCheckIsExists,
  doCommit,
  sendSmscode,
  uploadMultipartComplete,
  uploadMultipartInit,
  uploadMultipartUpload,
} from '@/api/contractUpload'
import { fetchUserInfo } from '@/api/user'
import { parseSpeed } from '@/utils/shared'

// const succTips = '信息提交成功，进入审核阶段，审核结果将<br>通过元气桌面消息中心通知您哦~'

const COOL_DOWN_TIME = 60

export default {
  name: 'ContractUpload',
  components: {
    ConfirmDialog,
    Loading,
    UpAuthDialog,
  },
  data() {
    return {
      chunkSize: 2097152,
      fileMaxSize: 200 * 1024 * 1024, // 200M
      remainingWords: 300,
      form: {
        user_desc: '',
        user_type: 1,
      },
      confirmDialogText: '',
      confirmDialogTitle: '',
      uploadVideoStatus: 'wait', // wait: 等待上传 process: 上传中 succ: 上传成功
      uploadComplete: 0, // 上传进度
      uploadSpeed: '',
      uploadPreLoaded: 0,
      uploadLoaded: 0,
      speedTimer: null,
      commiting: false,
      qaTipsVisible: true,
      sendSmscodeReady: true,
      treatyChecked: false,
      countdownSendSmscode: COOL_DOWN_TIME,
      showUpAuthDialog: false,
      userInfo: {},
    }
  },
  computed: {
    ...mapState({
      vuexUserInfo: state => state.userInfo,
      common: (state) => {
        return {
          token: state.userInfo.token,
          open_id: state.userInfo.open_id,
        }
      },
    }),
  },
  mounted() {
    this.fetchUserInfo()
    this.parseSmsCountdown()
    this.bind()
  },
  methods: {
    bind() {
      //
    },
    parseDesc(desc) {
      desc = desc.replace(/</g, '&gt;')
      desc = desc.replace(/>/g, '&lt;')
      return desc
    },
    parseSmsCountdown() {
      const now = +new Date()
      const cacheTime = +getSmsCoolDownTime() || 0
      const lefttime = parseInt((now - cacheTime) / 1000, 10)
      if (lefttime > COOL_DOWN_TIME) {
        this.sendSmscodeReady = true
        this.countdownSendSmscode = COOL_DOWN_TIME
        return COOL_DOWN_TIME
      }

      this.sendSmscodeReady = false

      this.countdownSendSmscode = COOL_DOWN_TIME - lefttime
      this.handleCountdownSendSmscode({
        isCache: true,
      })
      return lefttime
    },
    async checkMd5(md5) {
      try {
        const res = await this.doCheckIsExists(md5)
        const is_exist = res.is_exist !== undefined ? res.is_exist : res.data.is_exist
        if (is_exist) {
          if (res.data && res.data.resource_id) {
            this.form.resource_id = res.data.resource_id
            this.form.paper_url = res.data.resource_url
            this.form.video_preview_jpg = res.data.preview_jpg
            this.uploadVideoStatus = 'succ'
          } else {
            this.confirmDialogText = '已经上传过该视频，无需重复上传'
            this.confirmDialogTitle = ''
          }
          return false
        }
        return true
      } catch (err) {
        // TODO
      }
    },
    checkPhoneNumber(phoneNumber) {
      if (!parseInt(phoneNumber)) {
        return false
      }

      if (phoneNumber.length !== 11) {
        return false
      }

      return true
    },
    handleCountdownSendSmscode(options = {}) {
      const { isCache = false } = options
      clearInterval(this.countdownSendSmscodeTimer)
      this.countdownSendSmscodeTimer = setInterval(() => {
        this.countdownSendSmscode--
        if (this.countdownSendSmscode < 0) {
          clearInterval(this.countdownSendSmscodeTimer)
          this.sendSmscodeReady = true
          this.countdownSendSmscode = COOL_DOWN_TIME
        }
      }, 1000)
      if (!isCache) {
        saveSmsCoolDownTime(+new Date())
      }
    },
    async handleSendSmscode() {
      this.confirmDialogTitle = ''
      if (!this.form.phone_number) {
        this.confirmDialogText = '请输入手机号码'
        return
      }

      if (!this.checkPhoneNumber(this.form.phone_number)) {
        this.confirmDialogText = '请输入正确手机号码'
        return
      }

      this.sendSmscodeReady = false

      try {
        await sendSmscode({
          common: this.common,
          phone: this.form.phone_number,
        })
        this.handleCountdownSendSmscode()
      } catch (err) {
        this.sendSmscodeReady = true
        if (err.resp_common) {
          switch (err.resp_common.ret) {
            case 4901001:
              this.confirmDialogText = '请输入正确手机号码'
              break
            case 5901002:
              this.confirmDialogText = '发送验证码失败'
              break
            case 5001002:
              this.confirmDialogText = '服务器繁忙，请稍后重试'
              break
            default:
              this.confirmDialogText = err.resp_common.msg
          }
        } else {
          this.confirmDialogText = err.message
        }
      }
    },
    handleHideQaTips() {
      // 当下载量未达到100时，点击【认证元气UP】按钮，弹出未到100的提示。弹窗中【点击上传】作品跳转到上传作品页面。
      if (this.userInfo.works_download_cnt + this.userInfo.works_mobile_download_cnt < 100) {
        this.showUpAuthDialog = true
      } else {
        this.confirmDialogTitle = '重要提示'
        this.confirmDialogText = '请提交合法、真实且有效的身份证信息,若因您提交错误信息或者盗用他人身份证信息, 由此给您造成的任何风险, 请您自行承担。'
        this.qaTipsVisible = false
      }
    },
    handleTextareaChange($event) {
      const text = $event.currentTarget.innerHTML
      this.form.user_desc = text
    },
    handlePackageUpload($event) {
      this.confirmDialogTitle = ''
      const blobSlice = File.prototype.slice
      const file = $event.file

      if (!file.name || !file.name.match(/\.(mp4|rar|png|jpg|zip)$/ig)) {
        this.confirmDialogText = '请上传mp4、rar、png、jpg、zip格式文件'
        return
      }

      if (file.size > this.fileMaxSize) {
        this.confirmDialogText = '上传的视频不能超过 200M'
        return
      }

      const chunkSize = this.chunkSize
      const chunks = Math.ceil(file.size / chunkSize)
      let currentChunk = 0
      const spark = new SparkMD5.ArrayBuffer()
      const fileReader = new FileReader()
      const fileData = []

      fileReader.onload = async (e) => {
        // console.log('read chunk nr', currentChunk + 1, 'of', chunks)
        spark.append(e.target.result)
        fileData.push(e.target.result)
        currentChunk++
        if (currentChunk < chunks) {
          loadNext()
        } else {
          // console.log('finished loading', spark.end())
          const md5 = spark.end()
          if (await this.checkMd5(md5)) {
            this.multipartUpload(md5, file, fileData)
          }
        }
      }

      function loadNext() {
        const start = currentChunk * chunkSize
        const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize
        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
      }

      loadNext()
    },
    async multipartUpload(md5, file, fileData) {
      this.confirmDialogTitle = ''
      const params = {
        common: this.common,
        file_name: file.name,
        md5,
        file_type: 'live',
      }

      this.uploadVideoStatus = 'process'

      try {
        // 计算进度
        this.uploadComplete = 0

        // 计算速率
        this.uploadSpeed = ''
        this.uploadPreLoaded = 0
        this.uploadLoaded = 0
        // let time = 0
        this.speedTimer = setInterval(() => {
          // time++
          const speed = (this.uploadLoaded - this.uploadPreLoaded) / 1024
          if (speed) {
            this.uploadSpeed = parseSpeed(speed * 200)
          }
          // console.log('time:', time, 'speed:', speed, this.uploadSpeed, this.uploadPreLoaded)
          this.uploadPreLoaded = this.uploadLoaded
        }, 2000)
        const initRes = await uploadMultipartInit(params)
        if (!initRes.resp_common || initRes.resp_common.ret) {
          return
        }
        let completeLoaded = 0
        const uploadId = initRes.data.upload_id
        for (let i = 0, len = fileData.length; i < len; i++) {
          const item = fileData[i]
          // let nextSize = Math.min((i + 1) * this.chunkSize, file.size)
          const formData = new FormData()
          const blobData = new Blob([item])
          formData.append('file_part', blobData)
          formData.append('open_id', this.common.open_id)
          formData.append('token', this.common.token)
          formData.append('upload_id', uploadId)
          formData.append('part_size', blobData.size)
          formData.append('part_number', i + 1)

          const uploadRes = await uploadMultipartUpload(formData, {
            onUploadProgress: (progressEvent) => {
              const complete = progressEvent.loaded / progressEvent.total * 100 | 0

              this.uploadLoaded = completeLoaded + progressEvent.loaded
              this.uploadComplete = this.uploadLoaded / file.size * 100 | 0
              if (complete === 100) {
                completeLoaded += progressEvent.loaded
              }
            },
          })

          if (!uploadRes.resp_common || initRes.resp_common.ret) {
            return
          }
        }

        this.uploadComplete = 100
        clearInterval(this.speedTimer)

        params.upload_id = uploadId
        const completeRes = await uploadMultipartComplete(params)

        if (!completeRes.resp_common || completeRes.resp_common.ret) {
          return
        }

        // console.log('complete res:', completeRes)
        this.form.resource_id = completeRes.data.resource_id
        this.form.paper_url = completeRes.data.resource_url
        if (!this.previewUpload) {
          this.form.preview_jpg = completeRes.data.preview_jpg
        }
        this.form.video_preview_jpg = completeRes.data.preview_jpg
        this.uploadVideoStatus = 'succ'
      } catch (err) {
        this.uploadVideoStatus = 'wait'

        if (err.resp_common) {
          if (err.resp_common.ret === 4001002) {
            return
          }

          this.confirmDialogText = err.resp_common.msg
          return
        }

        this.confirmDialogText = err.message
      }

      clearInterval(this.speedTimer)
    },
    verification() {
      this.confirmDialogTitle = ''
      if (!this.vuexUserInfo.token) {
        EventEmit.$emit('SHOW_LOGIN_DIALOG')
        return false
      }

      if (!this.treatyChecked) {
        this.confirmDialogText = '请阅读并同意作者签约协议'
        return false
      }

      if (!this.form.idcard) {
        this.confirmDialogText = '请输入作者身份证'
        return false
      }

      if (!this.form.user_name) {
        this.confirmDialogText = '请输入作者姓名'
        return false
      }

      if (!this.form.phone_number) {
        this.confirmDialogText = '请输入手机号码'
        return false
      }

      if (!this.checkPhoneNumber(this.form.phone_number)) {
        this.confirmDialogText = '请输入正确手机号码'
        return false
      }

      if (!this.form.phone_code) {
        this.confirmDialogText = '请输入验证码'
        return false
      }

      if (!this.form.qq) {
        this.confirmDialogText = '请输入QQ号码'
        return false
      }

      if (!this.form.paper_url) {
        this.confirmDialogText = '请上传作品'
        return false
      }

      if (!this.form.paper_url) {
        this.confirmDialogText = '请上传作品'
        return false
      }

      if (!this.form.user_desc) {
        this.confirmDialogText = '请输入个人简介'
        return false
      }

      if (this.form.user_desc && this.form.user_desc.length > this.remainingWords) {
        this.confirmDialogText = `个人简介最多支持${this.remainingWords}个字哦`
        return false
      }

      return true
    },
    async handlePublish() {
      this.confirmDialogTitle = ''
      if (!this.verification()) {
        return
      }

      if (this.commiting) {
        return
      }

      this.commiting = true

      try {
        const data = Object.assign({
          common: this.common,
        }, this.form)
        const res = await doCommit(data)
        if (res.resp_common && !res.resp_common.ret) {
          this.confirmDialogText = '信息提交成功，进入审核阶段，审核结果将<br/>通过元气桌面消息中心通知您哦~'
          this.form.commit = true
        }
      } catch (err) {
        if (err.resp_common) {
          switch (err.resp_common.ret) {
            case 5001002:
              this.confirmDialogText = '服务器繁忙，请稍后重试'
              break
            case 4901003:
              this.confirmDialogText = '验证码错误'
              break
            case 4901002:
              this.confirmDialogText = '验证码过期'
              break
            case 4911020:
              this.confirmDialogText = '您已是元气UP'
              break
            default:
              this.confirmDialogText = err.resp_common.msg
          }
        } else {
          this.confirmDialogText = err.message
        }
      }

      this.commiting = false
    },
    handleConfirmDialogClose() {
      if (this.form.commit) {
        this.form = {
          user_desc: '',
        }
        this.$refs.textareaInput.innerHTML = ''
        this.uploadVideoStatus = 'wait'
        this.$router.push('/creation')
      }

      this.confirmDialogText = ''
      this.confirmDialogTitle = ''
    },
    handleRemoveVideoResource() {
      this.form.resource_id = 0
      this.form.paper_url = ''
      this.uploadVideoStatus = 'wait'
    },
    async doCheckIsExists(md5) {
      try {
        return await doCheckIsExists({
          common: this.common,
          md5,
        })
      } catch (err) {
        //
      }
    },
    async fetchUserInfo() {
      if (!this.common.token) {
        this.userInfo = {}
        return
      }
      try {
        const res = await fetchUserInfo({
          common: this.common,
        })
        if (res && res.resp_common && !res.resp_common.ret) {
          this.userInfo = res.user_info
        }
        console.log('fetchUserInfo', this.userInfo)
      } catch (err) {
      //
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.contract-upload-wrap {
  position: relative;
  width: 1200px;
  min-height: 640px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
}
.hd {
  padding: 34px 40px;
  .tip {
    font-size: 16px;
    color: #818181;
  }
}
.upload-form {
  display: flex;
  padding-bottom: 28px;
  .l {
    position: relative;
    width: 318px;
    margin-right: 10px;
    padding: 0 40px;
  }
}
.row {
  margin-bottom: 20px;
  // 两个元素一行
  .item2 {
    display: flex;
    gap: 20px;
  }
  .sub-row {
    flex: 1;
    &.flex1-3 {
      flex: 1.3;
    }
  }
  .sub-row + .sub-row {
    margin-left: 20px;
  }
  .gender-row {
    display: flex;
    padding-top: 10px;
    .el-radio {
      flex: 1;
      margin: 0;
      font-size: 12px;
    }
  }
  .el-radio, .el-checkbox {
    text-align: left;
  }
  .hl {
    font-style: normal;
    color: #f41c83;
  }
  .error {
    font-style: normal;
    font-size: 12px;
    color: #f41c83;
  }
  label {
    position: relative;
    display: block;
    margin-bottom: 10px;
    font-size: 16px;
    color: #333;
    .hl {
      position: absolute;
      left: -12px;
      top: 3px;
    }
  }
  .btn-send-code {
    margin-top: 32px;
  }
  .el-input, .el-textarea {
    font-size: 12px;
  }
  .confirm {
    position: absolute;
    left: 40px;
    bottom: 0;
    color: #333;
    label {
      display: inline-block;
    }
    a {
      margin-left: 5px;
      font-size: 12px;
      text-decoration: underline;
      color: #e88e01;
    }
  }
}
.ctrl {
  padding-top: 66px;
  .btn-publish {
    display: inline-block;
    width: 332px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    background: #f5b903;
    border-radius: 8px;
    color: #333;
    cursor: pointer;
  }
}

.r {
  width: 708px;
  label {
    display: block;
    margin-bottom: 10px;
    font-size: 16px;
    color: #333;
  }
  .poster-label {
    margin: 0;
    &::after {
      content: '';
      display: table;
      clear: both;
    }
    .txt {
      float: left;
      margin-top: 5px;
    }
    .btn-poster-upload {
      float: right;
    }
  }
}

.btn-poster-upload {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 120px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  font-size: 14px;
  background: #f5b903;
  border-radius: 8px;
  color: #333;
  overflow: hidden;
  font-weight: 700;
  input {
    position: absolute;
    left: 0;
    top: -200px;
    width: 120px;
    height: 600px;
    cursor: pointer;
  }
}

.poster-preview {
  position: relative;
  width: 318px;
  height: 180px;
  margin-top: 12px;
  background: #f3f3f3;
  .tips {
    position: relative;
    display: block;
    line-height: 180px;
    text-align: center;
    font-size: 12px;
    overflow: hidden;
    input {
      position: absolute;
      left: 0;
      top: -200px;
      width: 100%;
      height: 600px;
      cursor: pointer;
    }
  }
  .pic {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #f3f3f3;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .btn-remove {
    z-index: 2;
    position: absolute;
    right: 6px;
    top: 6px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 14px;
    background: #333;
    border-radius: 4px;
    color: #999;
    cursor: pointer;
  }
}

.upload-video {
  position: relative;
  width: 437px;
  height: 264px;
  border: 2px dashed #a5a5a5;
  .upload-info {
    margin: 105px 0 10px 0;
    font-weight: 700;
    font-size: 16px;
    color: #333;
  }
  .upload-sub {
    font-size: 12px;
    color: #333;
    .btn {
      display: inline-block;
      width: 45px;
      height: 20px;
      margin: 0 5px;
      line-height: 20px;
      text-align: center;
      font-weight: 700;
      background: #f5b903;
      border-radius: 2px;
      color: #333;
    }
  }
  .upload-tip {
    margin-top: 80px;
    font-size: 12px;
    font-weight: 700;
    color: #a5a5a5;
  }
}

.upload-video-process {
  position: relative;
  width: 437px;
  height: 264px;
  border: 2px dashed #a5a5a5;
  .upload-process-text {
    position: absolute;
    left: 0;
    right: 0;
    top: 180px;
    text-align: center;
    font-size: 16px;
    color: #333;
  }
  .upload-speed {
    position: absolute;
    left: 0;
    right: 0;
    top: 266px;
    text-align: center;
    font-size: 12px;
    color: #a5a5a5;
  }
}

.upload-video-succ {
  position: relative;
  width: 441px;
  height: 268px;
  &::after {
    content: '';
    z-index: 1;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(245, 185, 3, .3);
  }
  .pic {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    opacity: .2;
  }
  .btn-remove {
    z-index: 2;
    position: absolute;
    right: 6px;
    top: 6px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 14px;
    background: #333;
    border-radius: 4px;
    color: #999;
    cursor: pointer;
  }
  .icon-upload-succ {
    z-index: 2;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100px;
    height: 107px;
    margin: -70px 0 0 -50px;
    background: url('~@/assets/images/icon-upload-succ.png') 0 0 no-repeat;
    background-size: 100%;
  }
  .upload-succ-text {
    z-index: 2;
    position: absolute;
    top: 165px;
    left: 0;
    right: 0;
    text-align: center;
    // font-weight: 700;
    font-size: 16px;
    color: #333;
  }
}

.loading-progress {
  position: absolute;
  left: 162px;
  top: 47px;
}

.confirm-dalog-wrap {
  &::before {
    content: '';
    z-index: 9;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}

.el-select {
  display: block;
}

.flex-row {
  display: flex;
}

.tips-wrap {
  padding-top: 26px;
  .tips {
    margin-bottom: 15px;
    font-size: 12px;
    color: #A5A5AE;
  }
}

.btn-send-code {
  display: inline-block;
  width: 118px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  font-size: 14px;
  background: #F5B903;
  border-radius: 8px;
  cursor: pointer;
  color: #333;
  &.disable {
    background: #ddd;
    cursor: default;
  }
}
.form-textarea {
  position: relative;
  width: 694px;
  height: 57px;
  padding: 14px 0 14px 14px;
  font-size: 12px;
  background: rgba(243,243,244,1);
  border-radius: 2px;
  color: #A5A5AE;
  .textarea-inner {
    height: 57px;
    overflow: auto;
  }
  .textarea-input {
    min-height: 57px;
    outline: none;
  }
  .remaining-words {
    position: absolute;
    right: 7px;
    bottom: 7px;
  }
}

.qa-tip {
  z-index: 8;
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  height: 800px;
  width: 1200px;
  margin: 0 auto;
  border-radius: 10px;
  .inner {
    padding: 50px 40px 0;
  }
  h2 {
    margin-bottom: 32px;
    font-size: 24px;
  }
  dl {
    margin-bottom: 44px;
    line-height: 24px;
    dt {
      margin-bottom: 10px;
      font-weight: 700;
    }
  }
}

.qa-ctrl {
  padding-top: 15px;
  text-align: center;
}
</style>

<style lang="scss">
.el-radio__label {
  font-size: 12px;
}
.el-input__inner {
  background: #F3F3F4;
}
.el-upload-dragger {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: auto;
  height: auto;
  border: none;
  outline: none;
  &.is-dragover {
    border: none;
  }
}
.el-upload__tip {
  display: none;
}
.el-upload-list {
  display: none;
}
.confirm .el-checkbox__label {
  font-size: 12px;
}
.fs {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  height: 15px;
  line-height: 24px;
}
.bar {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#000, .5);
}
.up-auth-dialog {
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.confirm-dialog-wrap {
  .text{
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
